// extracted by mini-css-extract-plugin
export default {"card":"BackgroundForm_card__d0JAM","content":"BackgroundForm_content__PhNId"};